import { useState } from "react";
import { IconEye, IconEyeOff } from "@tabler/icons-react";
// @ts-expect-error pure js
import TextInput from "./TextInput";
import styles from "./PasswordInput.module.css";

interface PasswordInputProps {
  name: string;
  label: string;
  placeholder?: string;
  subText?: string;
  autoComplete?: string;
  marginForm?: string;
}

export default function PasswordInput(props: PasswordInputProps) {
  const [visible, setVisible] = useState(false);

  return (
    <TextInput
      type={visible ? "text" : "password"}
      unit={
        <button
          type="button"
          className={styles.toggle}
          onClick={() => setVisible((v) => !v)}
          aria-label={
            visible ? "Masquer le mot de passe" : "Afficher le mot de passe"
          }
        >
          {visible ? <IconEyeOff size={18} /> : <IconEye size={18} />}
        </button>
      }
      {...props}
    />
  );
}
